import React from 'react';
import { Card, CardHeader, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import SkeletonImage from '../SkeletonImage';

export function ChangelogIntro({ intro }) {
    return (
        <div className="gs-changelog-intro">
            <div className="gs-changelog-intro__portrait">
                <SkeletonImage
                    src="/chara_face_10007_2.png"
                    alt=""
                    loading="lazy"
                    frameClassName="gs-skeleton-frame--changelog-portrait"
                />
            </div>
            <blockquote className="gs-changelog-intro__bubble">
                <p>{intro}</p>
            </blockquote>
        </div>
    );
}

function RenderUnit({ unitname, unitid }) {
    return (
        <Link to={`/units/${unitname}`}>
            <SkeletonImage
                src={`/db/Units/Thumbnail/unit_thumbnail_${unitid}.webp`}
                alt={unitname}
                loading="lazy"
                frameClassName="gs-skeleton-frame--changelog"
            />
        </Link>
    );
}

function RenderEquip({ equipname, equipid }) {
    return (
        <Link to={`/equips/${encodeURIComponent(equipname)}`}>
            <SkeletonImage
                src={`/db/Equipment/Thumbnail/item_thumbnail_${equipid}.webp`}
                alt={equipname}
                loading="lazy"
                frameClassName="gs-skeleton-frame--changelog"
            />
        </Link>
    );
}

function ThumbRow({ children }) {
    return <div className="gs-inline-thumbs">{children}</div>;
}

export default function ChangelogArticle({
    date,
    intro,
    newUnits,
    newEquips,
    newDream,
    globalUnits,
    globalEquips,
    globalDream,
    showReturn = false,
}) {
    return (
        <Card className="gs-card gs-changelog-card">
            <CardHeader className="gs-card-header">
                <center><h1>{date}</h1></center>
            </CardHeader>
            <CardBody className="gs-card-body gs-changelog-body">
                <center>
                    <ChangelogIntro intro={intro} />

                    {newUnits?.length > 0 ? (
                        <>
                            <h3>The Following Unit(s) have been added:</h3>
                            <ThumbRow>
                                {newUnits.map(([unitname, unitid]) => (
                                    <RenderUnit key={unitid} unitname={unitname} unitid={unitid} />
                                ))}
                            </ThumbRow>
                        </>
                    ) : null}

                    {newEquips?.length > 0 ? (
                        <>
                            <h3>The Following Equip(s) have been added:</h3>
                            <ThumbRow>
                                {newEquips.map(([equipname, equipid]) => (
                                    <RenderEquip key={equipid} equipname={equipname} equipid={equipid} />
                                ))}
                            </ThumbRow>
                        </>
                    ) : null}

                    {newDream?.length > 0 ? (
                        <>
                            <h3>The Following Unit(s) have received a Dream Awakening in Japan:</h3>
                            <ThumbRow>
                                {newDream.map(([unitname, unitid]) => (
                                    <RenderUnit key={unitid} unitname={unitname} unitid={unitid} />
                                ))}
                            </ThumbRow>
                        </>
                    ) : null}

                    {globalUnits?.length > 0 ? (
                        <>
                            <h3>The Following Unit(s) have been added to Global Filters:</h3>
                            <ThumbRow>
                                {globalUnits.map(([unitname, unitid]) => (
                                    <RenderUnit key={unitid} unitname={unitname} unitid={unitid} />
                                ))}
                            </ThumbRow>
                        </>
                    ) : null}

                    {globalEquips?.length > 0 ? (
                        <>
                            <h3>The Following Equip(s) have been added to Global Filters:</h3>
                            <ThumbRow>
                                {globalEquips.map(([equipname, equipid]) => (
                                    <RenderEquip key={equipid} equipname={equipname} equipid={equipid} />
                                ))}
                            </ThumbRow>
                        </>
                    ) : null}

                    {globalDream?.length > 0 ? (
                        <>
                            <h3>The Following Unit(s) have had their Dream Awakenings added to Global:</h3>
                            <ThumbRow>
                                {globalDream.map(([unitname, unitid]) => (
                                    <RenderUnit key={unitid} unitname={unitname} unitid={unitid} />
                                ))}
                            </ThumbRow>
                        </>
                    ) : null}

                    <div className="gs-changelog-signoff">
                        <p>That is all for today. As usual, if you spot any bugs, incorrect information, or missing lore, please use the <a href='https://discord.com/channels/411427530860396545/413453985203355658'>#discord-feedback</a> channel on the Grand Summoners Official Discord.</p>
                        <p>Until Next Time,<br/>GSOD Team</p>
                    </div>

                    {showReturn ? (
                        <Link to="/news" className="gs-btn" style={{ marginTop: '1.5rem', display: 'inline-flex' }}>
                            Return to Changelogs
                        </Link>
                    ) : null}
                </center>
            </CardBody>
        </Card>
    );
}
